export const PUBLIC_ROUTES = {
  ERROR_404: "error/404",
  ERROR_500: "error/500",
  ERROR_401: "error/401",
  ERROR_403: "error/403",
  LOADING_SCREEN: "/loadingPage",
} as const;
